import { render, staticRenderFns } from "./AdverseEvents.vue?vue&type=template&id=5c28f126&scoped=true&"
import script from "./AdverseEvents.vue?vue&type=script&lang=js&"
export * from "./AdverseEvents.vue?vue&type=script&lang=js&"
import style0 from "./AdverseEvents.vue?vue&type=style&index=0&id=5c28f126&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c28f126",
  null
  
)

export default component.exports